// Client-side instrumentation: Sentry error monitoring + OpenTelemetry browser
// tracing. Imported for its side effects at the very top of `main.tsx` so it
// initializes before the React tree renders.
import { init } from '@sentry/react';

import { getEnvironment } from '@application/frontend-util/instrumentation-client';
import {
  initializeTelemetry,
  isE2EEnvironment,
} from '@application/frontend-util/telemetry-client';

// Sentry only runs in production builds, and never during E2E runs (identified
// by the fixed E2E port). The DSN is public client config, not a secret.
if (import.meta.env.PROD && !isE2EEnvironment()) {
  init({
    dsn: 'https://50f6e8bccbbd44db3c6e024adbbec12a@o4509240794939392.ingest.us.sentry.io/4510378447863808',
    debug: false,
    environment: getEnvironment(),
  });
}

// OpenTelemetry browser tracing. `initializeTelemetry` is a no-op in E2E and
// targets the local collector when running locally.
initializeTelemetry({ serviceName: 'ecosystem-manager' });
